
import {
    FETCH_VOICEMAILS_SUCCESS,
    FETCH_VOICEMAILS_ERROR,
    FETCH_VOICEMAILS_LOADING,

    RESET_VOICEMAILS,
    FETCH_MORE_VOICEMAILS_SUCCESS,
    FETCH_MORE_VOICEMAILS_LOADING,

    SET_VOICECHAT_PHONE_NO,
    FETCH_VOICECHAT_LOADING,
    FETCH_VOICECHAT_SUCCESS,
    FETCH_VOICECHAT_ERROR,

    UPDATE_NOTES_VOICEMAIL,
    FETCH_VOICECHAT_UNREAD_COUNT_SUCCESS

} from "../action/index" 

const defaultState= {
    data: [],
    error: null,
    isLoading: false,
    meta: [],
    isMoreLoading: false,
    chat_isLoading: false,
    chat_data: [],
    chat_phone_no: false,
    unread_count_data: [],
}

const VOICEMAILReducer = (state = defaultState, action ) => {
    let dupState = {...state}
    switch(action.type){
        case FETCH_VOICEMAILS_SUCCESS:
            return {...state, data: action.payload, isLoading: false, isMoreLoading:false, error: null, meta: action.meta}
        case FETCH_VOICECHAT_UNREAD_COUNT_SUCCESS:
            return {...state, unread_count_data: action.payload}
        case FETCH_VOICEMAILS_LOADING:
            return {...state, isLoading: true, isMoreLoading:true, error: null}
        case FETCH_VOICEMAILS_ERROR:
            return {...state, isLoading: false, error: "FETCH_VOICEMAILS_ERROR"}
        case RESET_VOICEMAILS:
            return {...state, data: [], isLoading: true, meta: []}
        case FETCH_MORE_VOICEMAILS_LOADING:
            return {...state, isMoreLoading: true}
        case FETCH_MORE_VOICEMAILS_SUCCESS:
            return {...state, data: dupState.data.concat( action.payload ), isLoading: false, error: null, meta: action.meta, isMoreLoading: false}
        case SET_VOICECHAT_PHONE_NO:
            return {...state, chat_phone_no: action.payload, chat_data: [], chat_isLoading: true}
        case FETCH_VOICECHAT_LOADING:
            return {...state, chat_isLoading: true}
        case FETCH_VOICECHAT_SUCCESS:
            return {...state, chat_isLoading: false, chat_data: action.payload}
        case FETCH_VOICECHAT_ERROR:
            return {...state, chat_isLoading: false}
        case UPDATE_NOTES_VOICEMAIL:
            let data = dupState.data
            let target = data.find( x => x.id === action.payload.id );
            target.note = action.payload.note
            return {...state, data}
        default:
            return {...state};
    }
}

export default VOICEMAILReducer;